import "vuetify/styles";
import { VDateInput } from "vuetify/labs/VDateInput";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";

export default createVuetify({
  components: { VDateInput },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
    variations: {
      colors: ["primary"],
      lighten: 3,
      darken: 3,
    },
    themes: {
      light: {
        colors: {
          primary: "#3b86df",
          accent: "#5aca81",
        },
      },
    },
  },
});
